<!--Form-->
<form autocomplete="nope" #form="ngForm">
    @if (hasQcPayrollFlag()) {
        <p>{{ 'payroll.taxReturns.amendment.selectEmployeesAndPackage' | translate }}</p>
    } @else {
        <p>{{ 'payroll.taxReturns.amendment.selectEmployees' | translate }}</p>
    }
    <mat-form-field class="w-100">
        <mat-label>{{ 'payroll.taxReturns.employee' | translate }}</mat-label>
        <ui-employee-autocomplete
            [placeholder]="'payroll.taxForms.addEmployee' | translate"
            name="selectEmployee"
            [(ngModel)]="addEmployee"
            [customQuery]="customEmployeeQuery"
            [statusDeterminer]="employeeStatusDeterminer"
            [filterEmployeeIds]="excludedEmployeeIds()"
            #selectEmployee="ngModel"
        ></ui-employee-autocomplete>
    </mat-form-field>
    @if (hasQcPayrollFlag()) {
        <mat-label>{{ 'payroll.taxReturns.amendment.package' | translate }}</mat-label>
        <div class="flex col">
            @for (packageType of RETURN_TYPES; track $index) {
                <mat-checkbox
                    [(ngModel)]="packages[packageType].isSelected"
                    [name]="packageType"
                    [disabled]="packages[packageType].isDisabled"
                    [matTooltip]="
                        submittedReturn() === packageType
                            ? ('payroll.taxReturns.amendment.alreadySubmittedTooltip' | translate)
                            : ('payroll.taxReturns.amendment.' + packageType + '.alreadyAddedTooltip'
                              | translate: { employee: addEmployee()?.fullName })
                    "
                    [matTooltipDisabled]="!packages[packageType].isDisabled"
                    matTooltipPosition="left"
                >
                    {{ 'payroll.taxReturns.amendment.' + packageType + '.packageType' | translate }}
                </mat-checkbox>
            }
        </div>
    }
</form>
